"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("../index.less");
var _index2 = _interopRequireDefault(require("@/components/reTitle/index"));
var _index3 = _interopRequireDefault(require("@/components/numCard/index"));
var _index4 = _interopRequireDefault(require("@/components/navs/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      titleInfo: {},
      bookList: [],
      pageSize: 2,
      total: 20
    };
  },
  methods: {
    lookAtAll: function lookAtAll() {},
    lookDetails: function lookDetails() {},
    getMajorId: function getMajorId() {},
    setsearchdata: function setsearchdata() {},
    handleSizeChange: function handleSizeChange() {},
    handleCurrentChange: function handleCurrentChange() {}
  },
  created: function created() {
    var v = this.$route;
    this.titleInfo.sec = v.meta.title;
    this.titleInfo.path = v.fullPath;
  },
  components: {
    RealTitle: _index2.default,
    NumCard: _index3.default,
    Navs: _index4.default
  }
};